<template>
  <div>
    <v-card class="pa-5 mb-5 elevation-hb">
      <h3>Ferramentas de Auxilio ao Dev</h3>
    </v-card>
    <v-row>
      <v-col>
        <v-card class="pa-5 mb-5 elevation-hb">
          Manutenção de Pedidos
          <v-text-field v-model="teste" placeholder="Inserir ID do Hubble" />

          <v-btn dark small @click="updateSingleOrder(teste)" depressed color="blue darken-1" class="pa-0 ma-1 rounded-md">
            <v-icon small dark>mdi-sync</v-icon>
          </v-btn>

          <v-btn dark small @click="resyncOrder(teste)" depressed color="yellow darken-1" class="pa-0 ma-1 rounded-md">
            <v-icon small>mdi-alert-rhombus</v-icon>
          </v-btn>
          <v-btn dark small @click="cancelOrder(teste)" depressed color="red darken-1" class="pa-0 ma-1 rounded-md">
            <v-icon small dark>mdi-cart-off</v-icon>
          </v-btn>
        </v-card>
      </v-col>
      <v-col>
        <v-card class="pa-5">
          <v-btn @click="massUpdate()" depressed color="blue" block dark>Atualização de Pedidos em Massa</v-btn>
        </v-card>
      </v-col>
      <v-col></v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'

export default {
  data: () => ({
    teste: null,
    loading: false,
  }),
  methods: {
    massUpdate(){
      const url = `${baseApiUrl}/orders/massUpdate`
      axios.get(url).catch(showError)
    },
    cancelOrder(orderIdHubble) {
      if (confirm(`Deseja Cancelar ${orderIdHubble}?`)) {
        this.loading = true
        let url = `${baseApiUrl}/order/${orderIdHubble}/cancel`
        axios.get(url).catch(showError)
      }
    },
    resyncOrder(orderIdHubble) {
      if (confirm('Deseja ressincronizar o pedido no Seller?')) {
        this.loading = true
        let url = `${baseApiUrl}/order/${orderIdHubble}/resync`
        axios.post(url).catch(showError)
      }
    },
    updateSingleOrder(orderIdMarketplace) {
      if (confirm('Deseja Atualizar a order?')) {
        this.loading = true
        let url = `${baseApiUrl}/vtex/updateSingleOrder`
        let object = { orderIdMarketplace: orderIdMarketplace }
        axios.post(url, object).catch(showError)
      }
    },
    loadContent(order) {
      let route = this.$router.resolve({
        name: 'Order',
        params: { id: order },
      })
      window.open(route.href, '_blank')
    },
  },
}
</script>

<style></style>
